module.exports = __webpack_public_path__ + "media/packs/images/partners/chance_bg-bbeacb732c5e86cfb08db7c6bce668ef.jpg";